import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
    fetchClinicalMeasurements,
    fetchLatestClinicalMeasurements
} from './clinicalMeasurements';

dayjs.extend(utc);
dayjs.extend(timezone);

const PATIENT_TYPES = [
    'M_HEARTRATE',
    'M_BLOOD_PRESSURE',
    'M_BLOOD_OXYGEN',
    'M_BLOOD_SUGAR',
    'M_BODY_TEMPERATURE',
    'M_WEIGHT'
];

// Preserve the formats consumed by existing patient cards and evolution charts.
export const getLatestMeasurements = async (patientUUID, { signal } = {}) => {
    const latest = await fetchLatestClinicalMeasurements({
        patient: patientUUID,
        types: PATIENT_TYPES,
        source: 'PATIENT',
        signal
    });
    return Object.fromEntries(
        Object.entries(latest).map(([type, record]) => [
            type,
            record ? [{ ...record.data, ts: record.ts, uuid: record.uuid }] : []
        ])
    );
};

export const getMeasurements = async (
    patientUUID,
    type,
    qi,
    qf,
    {
        timezone: zone = Intl.DateTimeFormat().resolvedOptions().timeZone,
        signal,
        source = 'PATIENT'
    } = {}
) => {
    const timestamp = dayjs.tz(qi, zone).toISOString();
    const endTimestamp = dayjs
        .tz(dayjs(qf).add(1, 'day').format('YYYY-MM-DD'), zone)
        .toISOString();
    const records = await fetchClinicalMeasurements({
        patient: patientUUID,
        type,
        source,
        timestamp,
        endTimestamp,
        signal
    });
    const ordered = [...records].sort((a, b) => Date.parse(a.ts) - Date.parse(b.ts));
    const keys = new Set(ordered.flatMap((record) => Object.keys(record.data || {})));
    keys.delete('ts');
    return {
        ...Object.fromEntries(
            [...keys].map((key) => [
                key,
                ordered.map((record) => record.data?.[key] ?? null)
            ])
        ),
        ts: ordered.map((record) => record.ts)
    };
};
